/**
 * Service: administrationApi
 */
angular.module('acme.common.service.administrationApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('AdministrationApiService', ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

  return {

    service: '',

    init: function(endpoint) {
      this.service = endpoint + '/administration';
      this.emailTemplates.service = endpoint + '/email/templates';
      this.languages.service = endpoint + '/languages';
      return this;
    },

    list: function() {
      var av = new ApiVersionFactory();

      return $http({
        method: 'get',
        url: av.init({ url: this.service, version: 'v2'})
      });
    },

    detail: function(id) {
      var av = new ApiVersionFactory();

      return $http({
        method: 'get',
        url: av.init({ url: this.service, version: 'v2'})
      });
    },

    update: function(props) {
      var av = new ApiVersionFactory();
      return $http({
        method: 'put',
        url: av.init({ url: this.service, version: 'v2' }),
        data: {
          id: props.id,
          name: props.name,
          streetAddress1: props.streetAddress1,
          streetAddress2: props.streetAddress2,
          city: props.city,
          state: props.state,
          zipCode: props.zipCode,
          country: props.country,
          phoneNumber: props.phoneNumber,
          companyUrl: props.companyUrl,
          logoImage: props.logoImage,
          timezone: props.timezone,
          consumerPage: props.consumerPage,
          abbreviatedName: props.abbreviatedName,
          giftCertificates: props.giftCertificates,
          reviews: props.reviews,
          coupons: props.coupons,
          membership: props.membership,
          membershipTicketTypeSelection: props.membershipTicketTypeSelection,
          membershipSales: props.membershipSales,
          membershipBenefitsExtension: props.membershipBenefitsExtension,
          membershipVerificationLastName: props.membershipVerificationLastName,
          allowAMEX: true,
          amexPaymentProcessor: props.paymentProcessor,
          paymentProcessor: props.paymentProcessor,
          surveyFrequency: props.surveyFrequency,
          offlinePin: props.offlinePin,
          allowPrintingForExpiredMemberships: props.allowPrintingForExpiredMemberships,
          enableSendGridTracking: props.enableSendGridTracking,
          enableCustomerInputOnPurchase: props.enableCustomerInputOnPurchase,
          externalSystemIntegration: props.externalSystemIntegration,
          enableExternalNotifications: props.enableExternalNotifications,
          allowUpgradeExternalMemberships: props.allowUpgradeExternalMemberships,
          invalidateExtraneousMembershipCards: props.invalidateExtraneousMembershipCards,
          vouchersRequireOrganization: props.vouchersRequireOrganization,
          enableGoogleAnalyticsTracking: props.enableGoogleAnalyticsTracking,
          enableGtmTracking: props.enableGtmTracking,
          notificationPreference: props.notificationPreference,
          sendGridProductionKey: props.sendGridProductionKey,
          sendGridSandboxKey: props.sendGridSandboxKey,
          disableMembershipManage: props.disableMembershipManage,
          rounding: props.rounding,
          billingAddress: props.billingAddress,
          b2bBillingAddress: props.b2bBillingAddress,
          passwordSecurityPolicyEnabled: props.passwordSecurityPolicyEnabled,
          passwordMinimumLength: props.passwordMinimumLength,
          passwordUseMixedCase: props.passwordUseMixedCase,
          passwordMinimumDigits: props.passwordMinimumDigits,
          passwordMinimumSymbols: props.passwordMinimumSymbols,
          sessionExpiryInMillis: props.sessionExpiryInMillis,
          settings: props.settings,
          printers: props.printers,
          expressURL: props.expressURL,
          expressAccountID: props.expressAccountID,
          expressAccountToken: props.expressAccountToken,
          expressApplicationID: props.expressApplicationID,
          expressAcceptorID: props.expressAcceptorID,
          creditCardValidationSettings: props.creditCardValidationSettings,
          featuresConfig: props.featuresConfig,
          lockAlwaysRequiredToUpdateRequiresLockObjects: props.lockAlwaysRequiredToUpdateRequiresLockObjects,
          lockExpiryInSeconds: props.lockExpiryInSeconds,
          auxiliaryMembership: props.auxiliaryMembership,
          sortTemplatesByDisplayOrder: props.sortTemplatesByDisplayOrder,
          allowTicketTransactionOnExpiredMemberships: props.allowTicketTransactionOnExpiredMemberships
        }
      });
    },

    tenantConfig: function(token) {
      var q = token ? '?passwordRecoveryToken=' + token: '';
      var av = new ApiVersionFactory();

      return $http({
        method: 'get',
        url: av.init({ url: this.service + '/tenantconfig' + q, version: 'v2'})
      });
    },
    
    /**
     * @param {{ email: string; password: string }} props
     */
    tenantConfigWithEmailPassword: function(props) {
      var av = new ApiVersionFactory();

      return $http({
        method: 'get',
        url: av.init({ url: this.service + '/tenantconfig', version: 'v2'}),
        headers: {
          'x-acme-email': props.email,
          'x-acme-password': props.password,
        }
      });
    },

    emailTemplates: {

      service: '',

      // ORDER(1, "order", "Order"),
      // REFUND(2, "refund", "Refund"),
      // REBOOK(3, "rebook", "Rebook"),
      // UPDATE(4, "update", "Update"),
      // ACCOUNT_CONFIRMATION(4, "accountConfirmation", "Account Confirmation"),
      // PASSWORD_RECOVERY(5, "passwordRecovery", "Password Recovery"),
      // CANCEL(6, "eventCancel", "Event Cancellation"),
      // VERIFY_MEMBERSHIP(7, "verifyMembership", "Membership Verification"),
      // MEMBERSHIP_RENEWAL(8, "membershipRenewal", "Membership Renewal"),
      // MEMBERSHIP_CARDS(9, "membershipCards", "Membership Card"),
      // MEMBERSHIP_GIFT(10, "membershipGift", "Membership Gift"),
      // TICKETS(11, "tickets", "Tickets"),
      // RESOURCE_ASSIGN(12, "assignResource", "Resource Assignment"),
      // RESOURCE_CANCEL(13, "cancelResource", "Resource Cancellation"),
      // RESOURCE_RESCHEDULE(14, "rescheduleResource", "Resource Rescheduled"),
      // DONATION(15, "donation", "Donation Only"),
      // EVENT_CANCELED(16, "eventCanceled", "Event Canceled"),
      // EVENT_RESCHEDULE(17, "eventRescheduled", "Event Reschedule"),

      list: function(props) {
        var q = '';

        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
            optional: ['page', 'pageSize', 'sortField', 'sortDirection']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + q
        }); 
      },

      update: function(props) {
        var av = new ApiVersionFactory();
        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/batch', version: 'v2' }),
          data: props
        });
      },

      /**
       * @param {{ sandboxApiKey: string; prodApiKey: string; templates: EmailTemplateMarshall[] }} props
       */
      verify: function(props) {
        var av = new ApiVersionFactory();
        return $http({
          method: 'post',
          url: av.init({ url: this.service + '/verify', version: 'v2' }),
          data: JSON.stringify(props)
        });
      }

    },

    languages: {

      service: '',

      list: function(props) {
        var av = new ApiVersionFactory();
        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/all', version: 'v2' }), 
        }); 
      },

      listCustom: function(props) {
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2')
        }); 
      },

      update: function(props) {
        var av = new ApiVersionFactory();
        return $http({
          method: 'put',
          url: av.init({ url: this.service, version: 'v2' }),
          data: props
        });
      },
    }
  };

}]);
